import { getDaysInMonth } from './utils.js'
import { durationSign } from '../Duration.js'

export function regulateISODate (year, month, day) {
  return constrainISODate(year, month, day)
}

export function rejectDuration (y, mon, w, d, h, min, s, ms, µs, ns) {
  const sign = durationSign(y, mon, w, d, h, min, s, ms, µs, ns)
  for (const prop of [y, mon, w, d, h, min, s, ms, µs, ns]) {
    if (!Number.isFinite(prop))
      throw new RangeError('infinite values not allowed as duration fields')
    const propSign = Math.sign(prop)
    if (propSign !== 0 && propSign !== sign)
      throw new RangeError('mixed-sign values not allowed as duration fields')
  }
}

export function rejectToRange (value, min, max) {
  if (value < min || value > max)
    throw new RangeError(`value out of range: ${min} <= ${value} <= ${max}`)
}

export function rejectISODate (year, month, day) {
  rejectToRange(month, 1, 12)
  rejectToRange(day, 1, getDaysInMonth(year, month))
}

export function rejectTime (
  hour,
  minute,
  second,
  millisecond,
  microsecond,
  nanosecond
) {
  rejectToRange(hour, 0, 23)
  rejectToRange(minute, 0, 59)
  rejectToRange(second, 0, 59)
  rejectToRange(millisecond, 0, 999)
  rejectToRange(microsecond, 0, 999)
  rejectToRange(nanosecond, 0, 999)
}

export function rejectDateTime (
  year,
  month,
  day,
  hour,
  minute,
  second,
  millisecond,
  microsecond,
  nanosecond
) {
  rejectISODate(year, month, day)
  rejectTime(hour, minute, second, millisecond, microsecond, nanosecond)
}

export function constrainToRange (value, min, max) {
  // Math.Max accepts undefined values and returns NaN. Undefined values are
  // used for optional params in the method below.
  return Math.min(max, Math.max(min, value))
}
function constrainISODate (year, monthParam, dayParam) {
  const month = constrainToRange(monthParam, 1, 12)
  const day = constrainToRange(dayParam, 1, getDaysInMonth(year, month))
  return { year, month, day }
}

export function constrainTime (
  hourParam,
  minuteParam,
  secondParam,
  millisecondParam,
  microsecondParam,
  nanosecondParam
) {
  const hour = constrainToRange(hourParam, 0, 23)
  const minute = constrainToRange(minuteParam, 0, 59)
  const second = constrainToRange(secondParam, 0, 59)
  const millisecond = constrainToRange(millisecondParam, 0, 999)
  const microsecond = constrainToRange(microsecondParam, 0, 999)
  const nanosecond = constrainToRange(nanosecondParam, 0, 999)
  return { hour, minute, second, millisecond, microsecond, nanosecond }
}

export function regulateTime (
  hourParam,
  minuteParam,
  secondParam,
  millisecondParam,
  microsecondParam,
  nanosecondParam,
  overflow
) {
  let hour = hourParam
  let minute = minuteParam
  let second = secondParam
  let millisecond = millisecondParam
  let microsecond = microsecondParam
  let nanosecond = nanosecondParam

  switch (overflow) {
    case 'reject':
      rejectTime(hour, minute, second, millisecond, microsecond, nanosecond)
      break
    case 'constrain':
      ;({ hour, minute, second, millisecond, microsecond, nanosecond } =
        constrainTime(
          hour,
          minute,
          second,
          millisecond,
          microsecond,
          nanosecond
        ))
      break
  }
  return { hour, minute, second, millisecond, microsecond, nanosecond }
}
